module.exports = __webpack_public_path__ + "static/media/status-confirmed.d92a817f.svg";